// components/CardBlock.tsx
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import remarkEmoji from "remark-emoji";
import { rehypeLinkTypes } from "../rehypePlugin/rehypeLinkType";
import { markdownComponents } from "../MarkdownComponent";

type CardBlockProps = {
  content: string;
};

export const CardBlock: React.FC<CardBlockProps> = ({ content }) => {
  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4 my-4">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks, remarkEmoji]}
        rehypePlugins={[rehypeLinkTypes]}
        components={markdownComponents}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
